import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import { AlertController } from '@ionic/angular';
import { Router, NavigationEnd, NavigationStart } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-homealert',
    templateUrl: './homealert.component.html',
    styleUrls: ['./homealert.component.scss'],
    standalone: false
})
export class HomealertComponent implements OnInit {

  public answered_yes: any;
  public navigate: Subscription
  public step = 1;

  constructor(public data: DataService, public router: Router,  public http: HttpClient) {

    //reset action alert box on navigate
    this.navigate = this.router.events.subscribe((event) => {
        if(event instanceof NavigationEnd && event.url == '/home'){
          this.step = 1
        }
    });



   }
  
  ionViewDidEnter(){
    console.log('ionViewDidEnter')
    this.data.sendLogMessage('home_alert_displayed');
  }

  unlock(){
    console.log("unlock");
    // Track "Unlocked" event when user presses YES on the lockscreen
    this.data.setEventsAnalytics('unlocked', 'event', {
      product_zone: 'Screening and symptom checker',
      questionnaire_id: this.data.treatment?.lockscreen?.questionnaire?.questionnaire?.id || null
    });
    this.data.sendLogMessage('tts_home_on', 'tts_home'); // Trigger info tooltip on event
    this.data.resetquestionnaire();
  }

  ngOnInit() {
    
    console.log('ngOnInit')
    console.log(this.answered_yes);
    let data = this.data;

    if(data.treatment.lockscreen && data.treatment.lockscreen.questionnaire && data.treatment.lockscreen.questionnaire.blockanswers)
    this.answered_yes = data.treatment.lockscreen.questionnaire.blockanswers.filter((e) => e.answer && !e.extra)


    this.navigate = this.router.events.subscribe((event) => {
      if(event instanceof NavigationStart && event.url == '/home'){
        
        if(data.treatment.lockscreen && data.treatment.lockscreen.questionnaire && data.treatment.lockscreen.questionnaire.blockanswers)
        this.answered_yes = data.treatment.lockscreen.questionnaire.blockanswers.filter((e) => e.answer && !e.extra)
        
      }
  });
  }

}
